
import { NumberRank } from 'src/app/enums/number/number-rank.enum';
import { StyleNumber } from 'src/app/enums/number/StyleNumber.enum';
import { routeEnvironment } from './route.environment';
const font = 'Open Sans';

export const coreEnvironment = {
  // maintenance
  maintenance: false,
  noData: '--',
  // main
  title: 'GNVERT LNG',
  logoPath: 'assets/images/gnvert-style/logo-gnvert.svg', // shiva-style: logoPath: 'assets/images/SHIVA-LOGO-PLAIN.svg',
  logoInline: 'assets/images/gnvert-style/logo-gnvert.svg', // shiva-style: logoInline: 'assets/images/SHIVA-LOGO-INLINE.svg',
  //API SORT PARAM
  sortFieldName: "sortFieldName",
  sortDirection: "sortDirection",

  // localstorage
  languageNameInSession: 'language',

  // routes : relative url, name, icon (class name)
  routes: routeEnvironment,

  // font
  mainFont: font,

  // ====================================
  //              TABLE
  // ====================================
  TABLE_NO_DATA_MESSAGE: 'Aucun résultat',

  // dates times format (moment)
  datetimeFormat: {
    datetime: 'L LTS',
    dateHourMinute: 'L LT',
    dateHour: 'L HH[h]',
    dayDate: 'ddd L',
    shortMonth: 'MMM',
    year: 'YYYY'
  },
  // for date picker library : date (2021-12-31)
  datePickerFormat: {
    date: 'DD/MM/YYYY',
    dateTime: 'DD/MM/YYYY HH:mm:ss'
  },
  data: {
    defaultStyle: StyleNumber.DECIMAL,
    defaultRank: NumberRank.UNIT,
    fixedPercent: 1,
    fixedCurrency: 0,
    fixedDecimal: 2,
    fixedDuration: 2
  },
  deliveries: {
    quantity: {
      min: 1,
      max: 25
    },
    pcs: {
      min: 15,
      max: 15.999,
      maxDecimalPlaces: 3
    }
  }
};
